import { css } from '@emotion/css';

const styles = {
  surface: css`
    display: flex;
    flex-direction: column;
    max-height: calc(100dvh - 2 * var(--spacing-600));

    @media (max-width: 668px) {
      height: 100dvh;
      max-height: 100dvh;
    }
  `,
  contentWrapper: css`
    max-height: none !important;
    flex: 1;
    min-height: 0;
    overscroll-behavior: contain;
  `,
  body: css`
    flex-direction: column;
    min-height: 100%;
  `,
  heading: css`
    @media (max-width: 668px) {
      font-size: var(--size-heading-xsmall);
      line-height: var(--line-height-heading-xsmall);
    }
  `,
  partnership: css`
    flex-wrap: wrap;
  `,
  partnerLogo: css`
    box-sizing: border-box;
    width: 140px;
    max-width: 100%;
    height: auto;
    padding: 10px;
  `,
  purchaseSection: css`
    @media (max-width: 668px) {
      position: sticky;
      bottom: 0;
      z-index: 1;
      margin-top: auto;
      background: var(--color-background-default);
      box-shadow: var(--elevation-top);
    }

    @media (max-width: 668px) and (max-height: 600px) {
      position: static;
    }
  `,
  secondaryAction: css`
    && {
      color: var(--color-text-weak);
      font-weight: 400;
    }

    @media (max-width: 668px) {
      text-decoration: underline;
    }
  `,
  description: css`
    color: var(--color-text-weak);
  `,
};

export default styles;
